import axios from 'axios';

export const updateProfile = async (payLoad, accessToken) => {
    const { data } = await axios.post(`${Env.API_URL}/user-profile`, payLoad, {
        headers: {
            Authorization : `Bearer ${accessToken}`,
        },
    });

    return data;
};

export const linkMembershipByToken = async (token, payLoad) => {
    const { data } = await axios.put(`${Env.API_URL}/user-profile/addUser`, payLoad, {
        headers: {
            Authorization : `Bearer ${token}`,
        },
    });
    return data;
};
